const ASTMDevices = {
    namespaced: true,
    state: {
        astm_device: {
            analyzer_name: null,
            analyzer_ip: null,
            analyzer_serial: null,
            authorized: false,
            active: false,
            user_id: null,
            id: null,
            device_id: null,
            name: null,
            pharmacy_site_id: null,
            dms_id: null,
            prn: null,
            proxy_mac_address: null,
            ip_address_mask: null,
            ip_gate: null,
            ip_dns: null,
            proxy_ip_address: null,
            ip_address_mask_two: null,
            listening_port: null,
            user: {
                username: null,
                password: null,
            },
            network_method: 'dhcp',
            open_vpn_username: null,
            open_vpn_pass: null,
            open_vpn_status: 'pending',
            image_generated: false,
            monitors_abnormality: false,
        },
        errorMessages: {
            astm_device: {
                analyzer_name: [],
                analyzer_ip: [],
                analyzer_serial: [],
                authorized: [],
                active: [],
                user_id: [],
                id: [],
                device_id: [],
                name: [],
                pharmacy_site_id: [],
                dms_id: [],
                prn: [],
                proxy_mac_address: [],
                ip_address_mask: [],
                ip_gate: [],
                ip_dns: [],
                proxy_ip_address: [],
                ip_address_mask_two: [],
                listening_port: [],
                user: {
                    username: [],
                    password: [],
                },
                network_method: [],
                open_vpn_username: [],
                open_vpn_pass: [],
                monitors_abnormality: [],
            },
        },
        pharmacySitesOptions: [],
        image_status: null,
    },
    mutations: {
        SET_ASTM_DEVICE_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            if (data.property === 'astm_device.name' && !state.astm_device.id) {
                _.set(state, 'astm_device.user.username', data.value);

                let vpnUsername = data.value;

                if (vpnUsername) {
                    vpnUsername = vpnUsername.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-');
                }

                _.set(state, 'astm_device.open_vpn_username', vpnUsername);
                return;
            }

            if (data.property === 'astm_device.network_method' && data.value === 'dhcp') {
                _.set(state, 'astm_device.ip_address_mask', null);
                _.set(state, 'astm_device.ip_gate', null);
                _.set(state, 'astm_device.ip_dns', null);
                _.set(state, 'astm_device.proxy_ip_address', null);
            }
        },
        SET_IMAGE_STATUS(state, data) {
            state.image_status = data.image_generated;
        },
        SET_PHARMACY_SITES_OPTIONS(state, data) {
            state.pharmacySitesOptions = data;
        },
        SET_ASTM_DEVICE(state, data) {
            state.astm_device = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
        SET_IP_ADDRESS(state, data) {
            state.analyzer_ip[data.property] = data.value;
        },
        RESET_ERROR_MESSAGES(state) {
            state.errorMessages = {
                astm_device: {
                    analyzer_name: [],
                    analyzer_ip: [],
                    analyzer_serial: [],
                    authorized: [],
                    active: [],
                    user_id: [],
                    id: [],
                    device_id: [],
                    name: [],
                    pharmacy_site_id: [],
                    dms_id: [],
                    prn: [],
                    proxy_mac_address: [],
                    ip_address_mask: [],
                    ip_gate: [],
                    ip_dns: [],
                    proxy_ip_address: [],
                    ip_address_mask_two: [],
                    listening_port: [],
                    user: {
                        username: [],
                        password: [],
                    },
                    network_method: [],
                    open_vpn_username: [],
                    open_vpn_pass: [],
                    monitors_abnormality: [],
                },
            };
        },
    },
    actions: {
        loadPharmacySitesOptions({ commit }) {
            axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        params: {
                            sort: 'name',
                        },
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_SITES_OPTIONS', data);
                });
        },
        updateProperty({ commit }, data) {
            commit('SET_ASTM_DEVICE_PROPERTY', data);
        },
        loadAstmDevice({ commit }, data) {
            commit('SET_ASTM_DEVICE', data);
            commit('SET_IMAGE_STATUS', data);
        },
        addIpAddress({ commit, state }) {
            if (state.astm_device && !state.astm_device.analyzer_ip) return;
            const ipAddress = state.astm_device.analyzer_ip.split('.');
            for (let i = 0; i < ipAddress.length; i++) {
                const data = { property: `analyzer_ip.address${i + 1}`, value: ipAddress[i] };
                commit('SET_ASTM_DEVICE_PROPERTY', data);
            }
        },
        resetErrorMessages({ commit }) {
            commit('RESET_ERROR_MESSAGES');
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.astm_device, fieldErrors.field);
                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'astm_device.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default ASTMDevices;
